import React, {Component} from 'react';
import {Container, Row, Col, Button} from 'reactstrap';
import { FormattedMessage } from 'react-intl';

class AccessDenied extends Component {
    render() {
        return (
            <Container className="restricted">
                <Row className="justify-content-center">
                    <Col md="6">
                        <div className="clearfix">
                            <h1 className="float-left display-3 mr-4 red-text-color"><i className="fa fa-warning"></i></h1>
                            <h4 className="pt-2 magenta-text-color">
                                <FormattedMessage id="accessDenied"
                                    defaultMessage="Access Denied"
                                />
                            </h4>
                            <p className="red-text-color float-left">
                                <FormattedMessage id="thePage"
                                    defaultMessage="The page you are looking for is restricted."
                                />
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}


export default AccessDenied;


// WEBPACK FOOTER //
// ./src/containers/AccessDenied.js